import heic2any from 'heic2any';

export async function convertHeicToJpeg(url) {
    try {
        // Check if the URL likely contains a HEIC image
        const isHeic = /\.(heic|heif)$/i.test(url) || url.includes('heic') || url.includes('HEIC');

        if (!isHeic) {
            return url; // Return original URL if not HEIC
        }

        // Fetch the HEIC image
        const response = await fetch(url);
        const blob = await response.blob();

        // Check if the blob is actually a HEIC image
        if (!blob.type.includes('heic') && !blob.type.includes('heif') && !isHeic) {
            return url; // Return original URL if not HEIC
        }

        // Convert HEIC to JPEG
        const convertedBlob = await heic2any({
            blob: blob,
            toType: 'image/jpeg',
            quality: 0.9
        });

        // Create a URL for the converted blob
        const convertedUrl = URL.createObjectURL(convertedBlob);

        return convertedUrl;
    } catch (error) {
        return url; // Return original URL on error
    }
}

export async function processImageUrls(urls) {
    // Process multiple URLs in parallel
    const processedUrls = await Promise.all(
        urls.map(url => convertHeicToJpeg(url))
    );
    return processedUrls;
} 